import { useEffect, useRef } from 'react';
import './Quote.css';

const quotes = [
    {
        text: "I warn you against shedding blood, indulging in it and making a habit of it, for blood never sleeps.",
        context: "On Leadership & Justice"
    },
    {
        text: "A true victory is not measured by the blood of the enemy, but by the mercy shown to those who surrender.",
        context: "On the Liberation of Jerusalem"
    },
    {
        text: "Youth, good health, and power eventually come to an end. Dedicate your life to something that will outlast you.",
        context: "On Legacy"
    }
];

const funFacts = [
    { icon: '💰', fact: 'When Saladin died, he had only one dinar and 47 dhirhams in his treasury — he had given everything away to the poor.' },
    { icon: '🤝', fact: 'During the Third Crusade, Saladin sent his personal physician and fresh fruit to King Richard I when Richard fell ill in battle.' },
    { icon: '⚔️', fact: 'The legendary Damascus steel sword was considered the greatest weapon of the era — and Saladin\'s armies wielded them masterfully.' },
    { icon: '📖', fact: 'He was a scholar who promoted education, building madrasas and hospitals across Egypt and Syria.' },
];

const Quote = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.querySelectorAll('.reveal, .reveal-left, .reveal-right, .quote__fact')
                            .forEach((el, i) => {
                                setTimeout(() => el.classList.add('revealed'), i * 120);
                            });
                    }
                });
            },
            { threshold: 0.1 }
        );
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <section id="quote" className="quote-section" ref={sectionRef}>
            <div className="quote-section__bg"></div>

            <div className="section-wrapper">
                <div className="quote-section__feature reveal">
                    <div className="quote-section__ornament">✦</div>
                    <div className="quote-section__mark">"</div>
                    <blockquote className="quote-section__text">
                        {quotes[0].text}
                    </blockquote>
                    <div className="quote-section__attr">
                        <span className="quote-section__dash">—</span>
                        <span className="quote-section__name">Salah Eldin El-Ayoubi</span>
                        <span className="quote-section__context">· {quotes[0].context}</span>
                    </div>
                    <div className="quote-section__ornament quote-section__ornament--bottom">✦</div>
                </div>


                <div className="quote-section__cards">
                    {quotes.slice(1).map((q, i) => (
                        <div key={i} className={`quote-section__card reveal delay-${i + 2}`}>
                            <span className="quote-section__card-mark">"</span>
                            <p className="quote-section__card-text">{q.text}</p>
                            <span className="quote-section__card-context">{q.context}</span>
                        </div>
                    ))}
                </div>


                <div className="quote-section__facts-header reveal">
                    <span className="section-tag">Did You Know?</span>
                    <h2 className="section-title">
                        The <span className="gold-text">Human</span> Behind the Legend
                    </h2>
                    <div className="divider"></div>
                </div>

                <div className="quote-section__facts-grid">
                    {funFacts.map((item, i) => (
                        <div key={i} className={`quote__fact delay-${i + 1}`}>
                            <span className="quote__fact-icon">{item.icon}</span>
                            <p className="quote__fact-text">{item.fact}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Quote;
